import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow
} from '../../../../../components/TableComponents'
import { ButtonRelation } from '../Components'
import { NegationButton } from '../Components/NegationButton'
import { ConfirmationButton } from '../Components/ConfirmationButton'
import { FormRecount } from '../FormRecount'
import { FormRecountKg } from '../FormRecountKg'
import ModalAddNotFoundBatch from '../ModalAddNotFoundBatch'
import { ModalResolveDivergence } from '../ModalResolveDivergence'
import ModalConfirm from '../ModalConfirm'
import { confirmBatchNotReceived, recountValidateUser } from 'src/services/receivement/divergenceService'
import { useLabelPrinting } from '../../../../../hooks/useLabelPrinting'
import * as S from './SubTableProductQuantity.styles'
import { batchMapper } from 'src/utils/mappers/batchMapper'
import { useReceivement } from 'src/hooks/useReceivement'
import { actions as appActions } from 'src/features/state'
import { useDispatch } from 'react-redux'
import { ModalNewBadgeForRecount } from '../ModalNewBadgeForRecount'

const SubTableProductQuantity = ({ product, badge, updateTable }) => {
  const [recountBatch, setRecountBatch] = useState()
  const [foundBatch, setFoundBatch] = useState()
  const [notFoundBatch, setNotFoundBatch] = useState()
  const [submitting, setSubmitting] = useState(false)
  const [allBatchesIds, setAllBatchesIds] = useState([])
  const [printAfterRecount, setPrintAfterRecount] = useState([])
  const { operatorName } = useReceivement({
    validateSupervisor: true
  })
  const [recountButtonDisabled, setRecountButtonDisabled] = useState(false)
  const [modalNewBadgeForRecountInfos, setModalNewBadgeForRecountInfos] = useState({
    batchId: undefined,
    batchCreatedBy: '',
    onSuccess: () => null
  })
  const [recountBadge, setRecountBadge] = useState(badge)

  const dispatch = useDispatch()

  const closeModalResolveDivergence = () => {
    setRecountBadge(badge)
    setRecountBatch(undefined)
    setFoundBatch(undefined)
    setNotFoundBatch(undefined)
  }

  const { showModalLabelPrinting, labelPrintingComponent } = useLabelPrinting({
    operatorName,
    onFinish: () => {}
  })

  const closeModalValidateRecount = () => {
    setModalNewBadgeForRecountInfos({
      batchId: undefined,
      batchCreatedBy: '',
      onSuccess: () => null
    })
  }

  const validateRecountBatch = async (
    index,
    batchId,
    isKg,
    dueDate,
  ) => {
    try {
      if (recountButtonDisabled) {
        return
      }

      setRecountButtonDisabled(true)

      dispatch(appActions.isLoading(true))

      const result = await recountValidateUser(batchId, recountBadge)
  
      if (result.isOk) {
        setRecountBatch({
          batchIndex: index,
          batchId,
          isKg,
          dueDate,
        })
      } else {
        if (result?.data?.error_code === 'BATCH_RECOUNT_SAME_USER') {
          setModalNewBadgeForRecountInfos({
            batchId: batchId,
            batchCreatedBy: result?.data?.username || '',
            onSuccess: (newBadge) => {
              closeModalValidateRecount()
              setRecountBadge(newBadge)
              setRecountBatch({
                batchIndex: index,
                batchId,
                isKg,
                dueDate,
              })
            }
          })
        } else {
          toast.error(result?.data?.message || 'Falha ao validar se usuário tem permissão para recontar o lote!')
        }
      }
    } catch (error) {
      toast.error('Falha ao validar usuário!')
    } finally {
      dispatch(appActions.isLoading(false))
      setRecountButtonDisabled(false)
    }
  }

  const getActionsDivergence = (product, batch, index) => {
    if (batch.status === 'NAO_LOCALIZADO') {
      return (
        <>
          <ConfirmationButton
            title="Localizado"
            onClick={() => {
              setFoundBatch({ batch, product })
            }}
          />
          <NegationButton
            title="Não Recebido"
            onClick={() => setNotFoundBatch({ batch, product })}
          />
        </>
      )
    } else if (['SOLICITAR_RECONTAGEM', 'RECONTADO'].includes(batch.status)) {
      const dueDate = batch.lote?.data_validade ? new Date(batch.lote.data_validade) : null
      
      if (dueDate) {
        dueDate.setHours(dueDate.getHours() + (dueDate.getTimezoneOffset() / 60))
      }

      return (
        <ButtonRelation
          title={batch.lote?.tipo_avaria === 'DANO' ? 'Recontar dano': 'Recontar'}
          isDamage={batch.lote?.tipo_avaria === 'DANO'}
          onClick={() =>
            validateRecountBatch(
              index,
              batch.id_lote,
              batch.lote.measure_unit.is_kg,
              dueDate,
            )
          }
          disabled={recountButtonDisabled}
        />
      )
    } else {
      return <></>
    }
  }

  const printLabel = (batches) => {
    const formattedBatches = []

    for (const batch of batches) {
      formattedBatches.push(batchMapper(batch))
    }
    showModalLabelPrinting(formattedBatches)
  }

  useEffect(() => {
    if (product && printAfterRecount.length > 0) {
      const batches = []
      const batchesIds = printAfterRecount

      const newAllBatches = product.lotes_divergencia.map((batch) => batch.id_lote)
      let difference = newAllBatches.filter(x => !allBatchesIds.includes(x))[0]

      if (difference) {
        batchesIds.push(difference)
      }

      for (const batchId of batchesIds) {
        const batchFount = product.lotes_divergencia.find((batch) => batch.id_lote === batchId)
        batches.push(batchFount.lote)
      }

      if (batches.length > 0) {
        printLabel(batches)
        setPrintAfterRecount([])
      }
    }

  }, [product, printAfterRecount, allBatchesIds])

  return (
    <>
      <Table>
        <TableHead>
          <TableHeadRow>
            <TableHeadCell></TableHeadCell>
            <TableHeadCell>Id Lote</TableHeadCell>
            <TableHeadCell>Status</TableHeadCell>
            <TableHeadCell isAction>Ações</TableHeadCell>
          </TableHeadRow>
        </TableHead>
        <TableBody>
          {product.lotes_divergencia.map((batch, index) => (
            <TableBodyRow key={batch.id_lote}>
              <TableBodyCell isDamage={batch.lote?.tipo_avaria === 'DANO'} isAction>
                {
                  <S.BatchPrintContainer
                    printEnable={
                      !['NAO_LOCALIZADO', 'NAO_RECEBIDO'].includes(
                        batch.status
                      )
                    }
                  >
                    <S.PrintButton
                      handleClick={() => printLabel([batch.lote])}
                    />
                  </S.BatchPrintContainer>
                }
              </TableBodyCell>
              <TableBodyCell isDamage={batch.lote?.tipo_avaria === 'DANO'}>
                  {batch.id_lote}                  
              </TableBodyCell>
              <TableBodyCell isDamage={batch.lote?.tipo_avaria === 'DANO'}>{batch.status}</TableBodyCell>
              <TableBodyCell isAction>
                <S.ActionContainer>
                  {getActionsDivergence(product, batch, index)}
                </S.ActionContainer>
              </TableBodyCell>
            </TableBodyRow>
          ))}
        </TableBody>
      </Table>

      <ModalResolveDivergence
        show={recountBatch?.batchId !== undefined}
        title={`Recontar lote de ID: ${recountBatch?.batchId}`}
        action={() => closeModalResolveDivergence()}
      >
        {recountBatch?.isKg ?
          <FormRecountKg
            batchId={recountBatch?.batchId}
            batchDueDate={recountBatch?.dueDate}
            product={product}
            badge={recountBadge}
            onSuccess={async () => {
              setAllBatchesIds(product.lotes_divergencia.map((batch) => batch.id_lote))
              toast.success('Contagem atualizada!')
              await updateTable()
              setPrintAfterRecount([recountBatch?.batchId])
              closeModalResolveDivergence()
            }}
            onFailure={(message) => {
              toast.error(message)
            }}
          />
          :
          <FormRecount
            batchId={recountBatch?.batchId}
            batchDueDate={recountBatch?.dueDate}
            badge={recountBadge}
            product={product}
            batchIndex={recountBatch?.batchIndex}
            printLabel={printLabel}
            onSuccess={async () => {
              setAllBatchesIds(product.lotes_divergencia.map((batch) => batch.id_lote))
              toast.success('Contagem atualizada!')
              await updateTable()
              setPrintAfterRecount([recountBatch?.batchId])
              closeModalResolveDivergence()
            }}
            onFailure={(message) => {
              toast.error(message)
            }}
          />
        }
      </ModalResolveDivergence>

      <ModalAddNotFoundBatch
        show={foundBatch && foundBatch.product && foundBatch.batch}
        action={() => closeModalResolveDivergence()}
        batchId={foundBatch?.batch.id_lote}
        isKg={foundBatch?.batch?.lote?.measure_unit?.is_kg}
        productDivergenceId={foundBatch?.product.id_produto_divergencia}
        productDescription={foundBatch?.product.descricao_produto}
        updateTable={updateTable}
        deliveryDaysMinExpirationDate={foundBatch?.product.delivery_days_min_expiration_date}
      />

      <ModalConfirm
        show={notFoundBatch && notFoundBatch.product && notFoundBatch.batch}
        alertText={
          <p>
            Confirma que não foi localizado lotes do produto:{' '}
            <b>{notFoundBatch?.product.descricao_produto}</b>
          </p>
        }
        noteText={
          'Não será possível adicionar mais lotes deste produto após a confirmação'
        }
        title={'Confirmação Lote Não Recebido'}
        onConfirm={() => {
          setSubmitting(true)
          confirmBatchNotReceived({
            batchId: notFoundBatch.batch.id_lote,
            productDivergenceId: notFoundBatch.product.id_produto_divergencia,
            badge
          })
            .then(() => {
              toast.success('Produto confirmado como NAO_RECEBIDO!')
              updateTable()
              setNotFoundBatch(undefined)
            })
            .catch((err) => {
              console.error(
                'Falha ao confirmar o produto como NAO_RECEBIDO: ',
                err
              )
              toast.error('Falha ao confirmar o produto como NAO_RECEBIDO!')
            })
            .finally(() => setSubmitting(false))
        }}
        action={() => setNotFoundBatch(undefined)}
        disabled={submitting}
      />

      <ModalNewBadgeForRecount
        batchId={modalNewBadgeForRecountInfos.batchId}
        batchCreatedBy={modalNewBadgeForRecountInfos.batchCreatedBy}
        onSuccess={modalNewBadgeForRecountInfos.onSuccess}
        onClose={closeModalValidateRecount}
      />

      {labelPrintingComponent}
    </>
  )
}

export { SubTableProductQuantity }
